<template lang="pug">
  .component-backoffice-notification-list.row.column
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="true",)
      header-columns(slot="before", :columns="headers")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'
  import HeaderColumns from "../../components/structure/ui/HeaderColumns";


  export default {
    name: 'NotificationList',
    components: {
      HeaderColumns,
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Notification.vue'),
        headers : ['user id','user type','message type', 'sent at',''],
      }
    },

    methods: {
      dataLoader(callback, page, resultsPerPage) {
        return KeplerBackofficeSdk.notifications.list(page, resultsPerPage).all((data) => {
          callback(data)
        })
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// NotificationsList.vue?68c33d73